import Get, {GetCat} from "../Get";
import { Grid, Space } from "../../Layout";
import { Texts, Button } from "../../Object";
import { SetDate } from "../SetDate.js";
import { SetImg } from "../SetImg.js";
import { useDocumentLoadCompleted } from "../../Hooks";
import { Link } from "react-router-dom";

const NewsList = (props) => {
  // Getオプション
  const args = {
    postType: "posts",
    perPage: props.perPage ? props.perPage : 3,
    page: props.page ? props.page : 1,
    offset: props.offset ? props.offset : 0,
    noimage: props.noimage ?? false,
  };
  const catArgs = {
    slug: "categories",
  };

  const isLoaded = useDocumentLoadCompleted();

  // post情報の取得
  const posts = Get(args);
  const cats = GetCat(catArgs);

  // 個別のエレメント情報
  const Item = (props) => {
    let post = {
      title: props.post.title.rendered, // タイトル
      id: props.post.id, // post id
      img: SetImg(props.post), // サムネイル
      date: SetDate(props.post.date), //　日付取得＆フォーマット
    };

    const gridProps = {
      wrap: {
        dir: "row",
        layout: "100%",
        size: ["100%", "100%"],
        gap: "24px",
      },
      body: {
        dir: "row",
        layout: "100%",
        size: "100%",
        gap: "16px",
      },
    };
    return (
      <>
        <Link to={`/post/${post.id}`}>
          <div
            className={`p-post__hover p-box__items--news `}
            data-state={args.noimage ? "" : "hasimage"}
          >
            <Grid {...gridProps.wrap}>
              {!args.noimage && (
                <img className="p-img__post" src={post.img} alt="media" />
              )}
              <Grid {...gridProps.body}>
                
                <div className="p-box__items--voice__cat__wrap">
                  {props.post["categories"].length > 0 ? (
                    props.post["categories"].map((cat) => <Cat cat={cat} />)
                  ) : (
                    <div className="p-box__items--voice__cat">
                      <p className="c-text__min c-text--bold">その他</p>
                    </div>
                  )}
                </div>
                <p className="c-text--en c-text__min ">{post.date}</p>

                <div className="p-box__items--service__button--inner">
                  <p className="c-text--bold c-text__title c-text__line-cut--single">
                    {post.title}
                  </p>
                  <div
                    className="c-button__img--arrow"
                    data-state="white"
                  ></div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Link>
      </>
    );
  };

  const Cat = (props) => {
    if (!cats) return true;
    const category = cats.find((cat) => cat.id == props.cat);
    return (
      <>
        <div className="p-box__items--voice__cat">
          <p className="c-text__min c-text--bold">{category.name}</p>
        </div>
      </>
    );
  };

  const Loading = (props) => {
    return (
      <>
      </>
    );
  };

  let items = [];
  if (posts && isLoaded) {
    // post情報取得後
    items = posts.map((post, key) => {
      return <Item key={key} post={post} />;
    });
  } else {
    // post情報取得中
    items.push(<Loading></Loading>);
  }

  return (
    // 全体のエレメント
    <>
      <ul
        className="c-grid__list--post"
        data-state={args.noimage ? "noimage" : ""}
      >
        {items}
      </ul>
    </>
  );
};

export default NewsList;
